module.exports = __webpack_public_path__ + "img/settings.622f5ab1.jpg";